/* eslint-disable no-restricted-globals */

import axios from "axios";
import utils from "@helpers/utils";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_SERVER_TEST === "ON"
      ? "http://dev-api.topconsuite.app.br/"
      : location.hostname.split(".")[0] === "dev"
        ? "https://test-api.topconsuite.app/customer"
        : `https://${location.hostname.split(".")[0]}-api.topconsuite.app`
});

const apiCustomer = axios.create({
  baseURL: utils.getBackendBaseUrl(false)
});

export { api, apiCustomer };
